<!-- 审核 -->
<template>
  <div class="diseaseList">
    <!-- 封装selectForm筛选 -->
    <el-form :inline="true">
      <el-form-item label="手机号: " style="margin: 0 20px 0 0" size="small">
        <el-input v-model="listQuery.phone" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="openid: " style="margin: 0 20px 0 0" size="small">
        <el-input v-model="listQuery.openid" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-button type="primary" @click="search" size="small" v-waves style="margin: 0 10px 10 0">搜索</el-button>
    </el-form>
    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="amount" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini">{{row.amount}}</el-tag>
        </template>
        <template slot="phone" slot-scope="scope">
          {{
          scope.row.phone ? scope.row.phone : "用户暂未绑定手机号"
          }}
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0);"
              @click="handleDelete(row)"
            >删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import Percentage from "@/components/filters/Percentage.vue";
import FillingStatus from "@/components/filters/FillingStatus.vue";
import KindTab from "@/components/tab/kindTab/index.vue";
import { selectApi, deleteApi } from "@/services/checkInRecord/index";
export default {
  components: {
    ElTable,
    Percentage,
    FillingStatus,
    KindTab
  },
  async created() {
    this.getListData();
  },
  data() {
    return {
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      /* 表格数据 */
      tableData: []
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader
  },
  watch: {},
  methods: {
    async getListData() {
      this.loading = true;
      const { data, code, count } = await selectApi(this.listQuery);
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    /* 搜索按钮 */
    async search() {
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },
    /* 删除 */
    handleDelete(row) {
      this.$confirm(`确定删除该数据吗?`, "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(res => {
        deleteApi({ id: row.id }).then(res => {
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          }
        });
      });
    }
  }
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}
.selectForm {
  background: #fff;
  // max-width: 1405px;
  padding: 10px 0;
  margin: 10px auto;
}
.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}
</style>
